import script from "./Notification.vue?vue&type=script&setup=true&lang=js"
export * from "./Notification.vue?vue&type=script&setup=true&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=dd865fb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd865fb6"]])

export default __exports__